import BaseProductStore from './BaseProductStore'

export default BaseProductStore
